import React, { FunctionComponent, useEffect } from 'react';

import queryString from 'query-string';

export const Intermediate: FunctionComponent = () => {
    useEffect(() => {
        // get the URL parameters which will include the auth token
        const params = window.location.search;

        if (window.opener) {
            // send them to the opening window
            window.opener.postMessage(queryString.parse(params), window.origin);
            // close the popup
            window.close();
        }
    }, []);

    return <p />;
};
